// extracted by mini-css-extract-plugin
module.exports = {"instagramWrapper":"Mg","innerTile":"Ng","heading":"Og","instaTileBtn":"Pg","disabled":"Qg","instaTileElement":"Rg","instagramPic":"Sg"};